import { EditorState, Modifier } from 'draft-js';

export const setTextAlignment = (textAlignment, editorState) => {
  const contentState = Modifier.mergeBlockData(editorState.getCurrentContent(), editorState.getSelection(), {
    textAlignment,
  });

  return EditorState.push(editorState, contentState, 'change-block-data');
};



// WEBPACK FOOTER //
// ./app/components/text-editor/modifiers/text-alignment-modifiers.js